import { SidebarContext } from "@components:Sidebar/Sidebar.Context";
import {
  Box,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SxProps,
  Typography,
} from "@mui/material";
import { ReactNode, useContext, useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

export interface SidebarSubMenuProps {
  children: ReactNode;
  title?: string;
  icon?: ReactNode;
  borderRadius?: string;
  disabled?: boolean;
  sx?: SxProps;
  fontSize?: string;
}

export const SidebarSubMenu = ({
  children,
  icon,
  title = "",
  borderRadius = "8px",
  disabled = false,
  sx,
  fontSize = "14px",
}: SidebarSubMenuProps) => {
  const sidebarContext = useContext(SidebarContext);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Box
      className="Sidebar__SubMenu"
      sx={{
        ...sx,
      }}
    >
      <ListItemButton
        sx={{
          whiteSpace: "nowrap",
          marginBottom: "2px",
          padding: "10px",
          borderRadius: borderRadius,
          color: open ? "#fff" : sidebarContext.itemTextColor,
          cursor: disabled ? "default" : "pointer",
          opacity: disabled ? "0.6" : "1",
          backgroundColor: !open
            ? undefined
            : sidebarContext.itemBackgroundColor,
          ".MuiListItemIcon-root": {
            color: open ? "#fff" : sidebarContext.itemTextColor,
          },
          "&:hover": {
            backgroundColor: open
              ? sidebarContext.itemBackgroundColor
              : sidebarContext.itemBackgroundColor + 20,
            color: open ? "#fff" : sidebarContext.itemBackgroundColor,
            ".MuiListItemIcon-root": {
              color: open ? "#fff" : sidebarContext.itemBackgroundColor,
            },
          },

          display: "flex",
          gap: "10px",
        }}
        onClick={handleClick}
      >
        {icon && (
          <ListItemIcon
            sx={{
              display: "flex",
              gap: "10px",
              marginBottom: "0px",
              padding: "0px",
              minWidth: "30px",
              cursor: "pointer",
              color: "inherit",
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        {!sidebarContext.isCollapse && (
          <>
            <ListItemText
              sx={{
                my: 0,
              }}
            >
              <Typography
                fontSize={fontSize}
                sx={{
                  lineHeight: "1",
                }}
                variant="caption"
              >
                {title}
              </Typography>
            </ListItemText>
            {open ? <MdExpandLess /> : <MdExpandMore />}
          </>
        )}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </Box>
  );
};
